import axios from 'axios';
import ApiConfig from './ApiConfig';

class Api {
  delete(endpoint, body, addAuthToken, useOldTenantHeader) {
    return axios.delete(
      `${process.env.BASE_API_URL}${endpoint}`,
      {
        ...ApiConfig.getHttpConfig(addAuthToken, useOldTenantHeader),
        data: body
      }
    ).then(this.handleSuccess);
  }

  get(endpoint, addAuthToken, useOldTenantHeader, options) {
    return axios.get(
      `${process.env.BASE_API_URL}${endpoint}`,
      ApiConfig.getHttpConfig(addAuthToken, useOldTenantHeader, options)
    )
      .then(this.handleSuccess);
  }

  post(endpoint, body, addAuthToken, useOldTenantHeader) {
    return axios.post(
      `${process.env.BASE_API_URL}${endpoint}`,
      body,
      ApiConfig.getHttpConfig(addAuthToken, useOldTenantHeader)
    )
      .then(this.handleSuccess);
  }

  put(endpoint, body, addAuthToken, useOldTenantHeader) {
    return axios.put(
      `${process.env.BASE_API_URL}${endpoint}`,
      body,
      ApiConfig.getHttpConfig(addAuthToken, useOldTenantHeader)
    )
      .then(this.handleSuccess);
  }

  handleSuccess(response) {
    return response.data;
  }
}

export default new Api();



// WEBPACK FOOTER //
// ./src/app/admin/services/api/index.js